import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${props => props.$fullScreen ? '100vh' : '200px'};
  padding: 2rem;
`;

const Spinner = styled.div`
  width: ${props => props.$size || 50}px;
  height: ${props => props.$size || 50}px;
  border: 4px solid #e2e8f0;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const BounceDots = styled.div`
  display: flex;
  gap: 0.5rem;
  margin: 1rem 0;
  
  span {
    width: 12px;
    height: 12px;
    background: #3b82f6;
    border-radius: 50%;
    animation: ${bounce} 1.4s ease-in-out infinite;
    
    &:nth-child(1) { animation-delay: -0.32s; }
    &:nth-child(2) { animation-delay: -0.16s; }
  }
`;

const LoaderText = styled.p`
  color: #64748b;
  margin-top: 1rem;
  font-size: 0.9rem;
`;

export const Loader = ({ type = 'spinner', size, fullScreen = false, text = 'Загрузка...' }) => {
  return (
    <LoaderContainer $fullScreen={fullScreen}>
      {type === 'spinner' && <Spinner $size={size} />}
      {type === 'dots' && <BounceDots><span /><span /><span /></BounceDots>}
      {text && <LoaderText>{text}</LoaderText>}
    </LoaderContainer>
  );
};

const skeletonLoading = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

const SkeletonElement = styled.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${skeletonLoading} 1.5s infinite;
`;

export const Skeleton = ({ width = '100%', height = '200px', borderRadius = '12px', style }) => (
  <SkeletonElement style={{ width, height, borderRadius, ...style }} />
);

export const CardSkeleton = () => (
  <div style={{ padding: '1rem' }}>
    <Skeleton height="200px" />
    <Skeleton height="20px" width="80%" style={{ marginTop: '1rem' }} />
    <Skeleton height="16px" width="60%" style={{ marginTop: '0.5rem' }} />
  </div>
);